import contextMenuSchema from './contextmenu-schema.graphql';

export { contextMenuSchema };
